import React from "react";

type BarShadowFilterProps = {
	id: string;
	isHighlighted: boolean;
};

export const BarShadowFilter: React.FC<BarShadowFilterProps> = ({
	id,
	isHighlighted,
}) => (
	<filter id={id} x="-30%" y="-30%" width="160%" height="160%">
		{isHighlighted ? (
			<feDropShadow
				dx="0"
				dy="4"
				stdDeviation="5"
				floodColor="#000"
				floodOpacity="0.2"
			/>
		) : (
			<feDropShadow dx="0" dy="1" stdDeviation="1" floodOpacity="0.1" />
		)}
	</filter>
);
